import dayjs from 'dayjs';
import api from '~/api';
import { RevenueShareResponse, RevenueShareStatusResponse } from '../dtos/revenueShareResponse';
import { RevenueShareLedger, RevenueShareStatus } from '../models/revenueShare.model';

const RevenueShareStatusMap: Record<RevenueShareStatusResponse, RevenueShareStatus> = {
  open: RevenueShareStatus.open,
  paid: RevenueShareStatus.paid,
  in_progress: RevenueShareStatus.submitted,
};

export async function getRevenueShareLedger(partnerId: string): Promise<RevenueShareLedger> {
  const { data } = await api.get<RevenueShareResponse[]>(`v1/revenue_share/partner/${partnerId}`);

  const ledger = new RevenueShareLedger();
  data.forEach((response) => {
    return ledger.add(
      RevenueShareStatusMap[response.status],
      response.account.business_name,
      response.fee,
      response.percentage,
      response.total,
      dayjs(response.billed_period_start),
      response.payment_date ? dayjs(response.payment_date) : null
    );
  });

  return ledger;
}
